import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Divider, Typography } from '@mui/material';

import { ControlledInputs } from '@/components';
import {
  chargeableRateOptions,
  positionTypeOptions,
} from '@/features/settings/hooks/constants';

import { useCompanyDetails, useUserProfileFormContext } from '../hooks';

export const UserProfileForm = () => {
  const form = useUserProfileFormContext();
  const { loading, handleUseCompanyDetails } = useCompanyDetails(form);

  return (
    <Box>
      <Typography variant="title1">Contact Information</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          marginTop: '1em',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `first_name`,
            }}
            label="First Name"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `last_name`,
            }}
            label="Last Name"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `position`,
            }}
            label="Company Position"
          />

          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: `position_type`,
            }}
            optionKeys={{ label: 'label', value: 'value' }}
            options={positionTypeOptions}
            label="Position Type"
          />
          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: `chargeable_rate`,
            }}
            optionKeys={{ label: 'label', value: 'value' }}
            options={chargeableRateOptions}
            label="Chargeable Rate"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `quals`,
            }}
            label="Personal Qualification"
          />
        </Box>
        <Box>
          <Divider
            orientation="vertical"
            sx={{
              marginX: '28px',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '17px',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <PrimaryButton disabled={loading} onClick={handleUseCompanyDetails}>
              Use Company Details
            </PrimaryButton>
          </Box>

          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `address`,
            }}
            label="Address"
          />

          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `suburb`,
            }}
            label="Suburb"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `state`,
            }}
            label="State"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `postcode`,
            }}
            label="Post Code"
          />
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `phone_number`,
            }}
            label="Phone Number"
          />
        </Box>
      </Box>
    </Box>
  );
};
